'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import DocLink from 'ui-forms-components/links/DocLink';
import { LegalConsentOptions } from 'FormsCommonComponents/constants/LegalConsent';
import LegalConsentOptionSelectInput from 'FormsCommonComponents/LegalConsentOptionSelectInput';
import { LEGAL_CONSENT } from 'FormsCommonComponents/constants/KCSArticlePaths';
import { trackUpdateGdprOption } from 'FormsUI/tracking/legalConsentTracking';
import { View } from 'foundations-components/transitional/components/View';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `formsLegalText.selectOption.${suffix}`;
const link = /*#__PURE__*/_jsx(DocLink, {
  path: LEGAL_CONSENT,
  use: "link-on-dark",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: langKey('info.link')
  })
});
const tooltipTitle = /*#__PURE__*/_jsx(FormattedReactMessage, {
  message: langKey('info.tooltip'),
  options: {
    learnMoreLink: link
  }
});
const LegalConsentTitle = () => /*#__PURE__*/_jsxs(TFlex, {
  children: [/*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('accordionTitle')
    })
  }), /*#__PURE__*/_jsx(Box, {
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipTitle,
      children: /*#__PURE__*/_jsx(InfoIcon, {
        size: "400"
      })
    })
  })]
});
export const LegalConsentDeleteButton = ({
  handleSelect = () => {}
}) => /*#__PURE__*/_jsx(IconButton, {
  tooltip: "Delete",
  "data-test-id": "delete-GDPR",
  onClick: () => {
    handleSelect(LegalConsentOptions.NONE);
  },
  children: /*#__PURE__*/_jsx(DeleteIcon, {
    size: "300"
  })
});
const LegalConsentSelect = ({
  selectLegalConsentOption = () => {},
  currentLegalConsentOption = LegalConsentOptions.NONE
}) => {
  const handleSelectLegalConsent = value => {
    trackUpdateGdprOption(currentLegalConsentOption, value);
    selectLegalConsentOption(value);
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "500",
    as: "div",
    children: [/*#__PURE__*/_jsx(LegalConsentTitle, {}), /*#__PURE__*/_jsxs(TFlex, {
      children: [/*#__PURE__*/_jsx(LegalConsentOptionSelectInput, {
        id: "gdpr-select",
        buttonUse: "form",
        onChange: handleSelectLegalConsent,
        option: currentLegalConsentOption
      }), currentLegalConsentOption !== LegalConsentOptions.NONE && /*#__PURE__*/_jsx(LegalConsentDeleteButton, {
        handleSelect: handleSelectLegalConsent
      })]
    })]
  });
};
export default LegalConsentSelect;